import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InputText from "../../components/input/InputText";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { authAPI } from "../../apis";
import axios from "axios";
import { toast } from "react-toastify";

const VerifyConfirmation = (props) => {
  const { confirmationPopup, setConfirmationPopup } = props;
  const [email, setEmail] = useState("");

  const handleSave = async () => {
    try {
      await axios.post(`${authAPI.notifyConfirmationEmail}?email=${email}`);
      toast.success(
        "We have successfully received your request to confirm your email. We will respond to you shortly."
      );
      setConfirmationPopup(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSave();
    }
  };

  return (
    confirmationPopup && (
      <>
        <div className="bg-dark-new" />
        <div
          onKeyDown={(e) => handleKeyDown(e)}
          className="verify-confirmation-popup"
          tabIndex="0"
        >
          <div className="popup-card">
            <CloseIcon
              className="cross"
              onClick={() => {
                setConfirmationPopup(false);
              }}
            />
            <p className="popup-title">Help! I need to confirm my email!</p>

            <ol className="custom-ol">
              <li>
                Open a blank email from the account you are trying to
                authenticate.
              </li>
              <li>Put in the subject line "I need to confirm my email".</li>
              <li>
                Send the email to{" "}
                <span className="bold">emailsupport@sooth.fyi.</span>
              </li>
              <li>
                Wait 5 minutes and try to sign in using your email and password.
              </li>
              <li>
                If you are still experiencing difficulty, contact us here{" "}
                <a className="bold underline" href="mailto:contact@sooth.fyi">
                  [contact@sooth.fyi]
                </a>
                .
              </li>
            </ol>

            <div className="save-actions">
              <div />
              <div className="flex">
                <ButtonPrimary
                  text="Okay"
                  onClick={() => setConfirmationPopup(false)}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default VerifyConfirmation;
